var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeModelName)?_c('div',{staticClass:"model-name-display"},[_vm._v(" "+_vm._s(_vm.activeModelName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }